import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DetailZittingService, IAgendapunt, IDetailAgendapunt, GroeperenService, IZittingResult, IAtHomePersoonNotitieZitting } from '../detail-zitting.service';
import { MenuService } from '../../shared/menu.service';
import { jumpToAnchor } from '../../shared/helpers';
import { IReturnData, state2 } from '../../shared/state';
import { StandpuntService, IAgendapuntStandpuntInfo } from '../../standpunten/standpunt.service';
import { IDocumentDb, IZittingDb } from '../../shared/offline/cobradb';
import { AppService } from '../../shared/app.service';
import { Observable, Subject, combineLatest, firstValueFrom, merge } from 'rxjs';
import { map, switchMap, mergeMap, scan, shareReplay, filter, withLatestFrom } from 'rxjs/operators';
import { createCmdFactory, arrayReplace } from '@cevi/rxjscommands';
import { ZeroPipe } from '../../shared/zero.pipe';
import { DetailPuntComponent } from '../detail-punt/detail-punt.component';
import { BepaalStandpuntComponent } from '../../standpunten/bepaal-standpunt/bepaal-standpunt.component';
import { NgIf, NgFor, NgClass, NgSwitch, NgSwitchCase, AsyncPipe, DatePipe } from '@angular/common';

interface IDetailZittingVm {
  agendapunten: IAgendapunt[];
  documenten: IDocumentDb[];
  standpunten?: IAgendapuntStandpuntInfo[];
  zitting?: IZittingDb;
  currentpunt?: IAgendapunt;
  currentdetailpunt?: IDetailAgendapunt;
  currentStandpunt?: IAgendapunt;
  groeperenService?: GroeperenService;
  //bespreken: boolean;
  viewState: IViewState;
  notities?: IAtHomePersoonNotitieZitting[];
  returnData?: IReturnData
}

interface IZittingParams {
  zittingid: number;
  bespreken: boolean;
}

interface IViewState {
  bespreken?:boolean;
  nietbespreken?:boolean;
  notities?:boolean;
  name:string;
  besprekenClass:string;
  nietbesprekenClass:string;
  notitiesClass:string;
}
const besprekenViewState : IViewState = {
  bespreken:true,
  name:'bespreken',
  besprekenClass:'btn-primary',
  nietbesprekenClass:'btn-default',
  notitiesClass:'btn-default'
}
const nietbesprekenViewState : IViewState= {
  nietbespreken:true,
  name:'nietbespreken',
  besprekenClass:'btn-default',
  nietbesprekenClass:'btn-primary',
  notitiesClass:'btn-default'
}
const notitiesViewState : IViewState = {
  notities:true,
  name:'notities',
  besprekenClass:'btn-default',
  nietbesprekenClass:'btn-default',
  notitiesClass:'btn-primary'
}

const emptyVm: IDetailZittingVm = {
  agendapunten: [],
  documenten: [],
  viewState: nietbesprekenViewState
};

const viewStateMap = {
  "bespreken": besprekenViewState,
  "nietbespreken": nietbesprekenViewState,
  "notities": notitiesViewState
};


@Component({
    selector: 'app-detail-zitting',
    templateUrl: './detail-zitting.component.html',
    styleUrls: ['./detail-zitting.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgIf, NgFor, NgClass, NgSwitch, NgSwitchCase, BepaalStandpuntComponent, DetailPuntComponent, AsyncPipe, DatePipe, ZeroPipe],
    providers:[DetailZittingService, StandpuntService]
})
export class DetailZittingComponent implements OnInit {

  public nietbesprekenViewState= nietbesprekenViewState;
  public besprekenViewState= besprekenViewState;
  public notitiesViewState = notitiesViewState;

  vm$: Observable<IDetailZittingVm>;
  vm: IDetailZittingVm;

  // zittingid
  toggleMyMeetingStatusSubj = new Subject<number>();
  bookmarkAgendapuntSubj = new Subject<IAgendapunt>();
  detailPuntSubj = new Subject<IAgendapunt>();
  bepaalStandpuntSubj = new Subject<IAgendapunt>();
  closeStandpuntSubj = new Subject<boolean>();
  toonNotitiesZittingSubj = new Subject<number>();
  cmdFactory =createCmdFactory<IDetailZittingVm>();
  isReload:boolean=true;

  constructor(private detailZittingService: DetailZittingService,
    private standpuntService: StandpuntService,
    public appService: AppService,
    private route: ActivatedRoute,
    public menuService: MenuService) {

      this.cmdFactory.setLocalDebug();

    this.appService.routing.createCurrentHistoryItem('Naar de zitting');
    this.cmdFactory.addMapAction(this.zittingFromQueryParamsAction$, 'zittingFromQueryParams');
    this.cmdFactory.addMapAction(this.bookmarkAgendapuntAction$, 'bookmarkAgendapunt');
    this.cmdFactory.addMapAction(this.meetingStatusAction$, 'meetingStatus');
    this.cmdFactory.addMapAction(this.bepaalStandpuntAction$, 'bepaalStandpunt');
    this.cmdFactory.addMapAction(this.closeStandpuntenAction$, 'closeStandpunten');
    this.cmdFactory.addMapAction(this.detailPuntFromSubj$, 'detailPuntFromSubj');
    this.cmdFactory.addMapAction(this.notitiesResultFromParamMap$,'notities');
    this.vm$ = this.cmdFactory.merge(emptyVm);
  }

  private queryParams$ = this.route.paramMap.pipe(
    map(paramMap => ({ zittingid: +paramMap.get('zittingid'), viewstatename: paramMap.get('viewstatename') })),
  );

  private forceRefresh$ = merge(this.closeStandpuntSubj, this.appService.refresh$).pipe(map(_ => true));
  private allowFromCache$ = this.queryParams$.pipe(map(_ => false));

  private zittingResultFromParamMap$ = merge(this.forceRefresh$, this.allowFromCache$).pipe(
    withLatestFrom(this.queryParams$),
    filter(([refresh,qp])=>qp.viewstatename!==notitiesViewState.name || this.isReload),
    switchMap(([refresh, qp]) => {
      this.isReload=false;
      return  this.detailZittingService.getDetailZitting(qp.zittingid, qp.viewstatename===besprekenViewState.name, refresh)
    })
  );

  private notitiesResultFromParamMap$ = merge(this.forceRefresh$,this.allowFromCache$).pipe(
    withLatestFrom(this.queryParams$),
    filter(([refresh,qp])=>qp.viewstatename===notitiesViewState.name),
    switchMap(async ([refresh,qp])=> {
      const notities = await firstValueFrom(this.detailZittingService.notitiesForZiting$(qp.zittingid));
      return {notities, viewstate:notitiesViewState};
    }),
    map(result => (vm:IDetailZittingVm)=> ({...vm, notities:result.notities, viewState:result.viewstate}))
  );

  public exportNotities=(zittingId:number)=>{
    const url = this.appService.getUrl('api/notitie/GetNotitiesZittingExport/'+zittingId);
    window.open(url, '_blank');
  }
  

  private zittingFromQueryParamsAction$ = combineLatest([this.queryParams$, this.zittingResultFromParamMap$]).pipe(
    map(([params, zittingResult]) => (vm: IDetailZittingVm) => {
      // this.appService.setZittingId(params.zittingid); // TEST REFRESH
      if (!this.appService.routing.backHistoryItem) {
        this.appService.routing.backHistoryItem = {
          commands: ['dashboard'],
          timestamp: new Date(),
          title: 'Dashboard'
        };
      }
      const agendapunten = params.viewstatename === besprekenViewState.name
        ? zittingResult.detail.agendapunten.filter(a => a.Bespreken)
        : zittingResult.detail.agendapunten;

      const newVm : IDetailZittingVm = {
        ...vm,
        zitting: zittingResult.detail.zitting,
        documenten: zittingResult.detail.documenten,
        agendapunten,
        returnData: state2.popReturnData(),
        groeperenService: new GroeperenService(zittingResult.groeperingsIds),
        viewState: (params.viewstatename ? viewStateMap[params.viewstatename] : nietbesprekenViewState)
      };
      const groupedVm = this.groepeerAgendapunten(newVm);
      if (this.route.snapshot.paramMap.has('docid')) {
        const docid = +this.route.snapshot.paramMap.get('docid');
        const document = newVm.documenten.find(d => d.Id === docid);
        this.openDocumentZitting(document);
      }
      jumpToAnchor(this.route.snapshot.fragment);
      return groupedVm;
    }),
  );

  groepeerAgendapunten(vm: IDetailZittingVm) {
    let lastDienst = null;
    vm.groeperenService.initialize();
    vm.agendapunten.forEach(punt => {
      lastDienst = punt.Dienst;
      punt.GroupLevel = vm.groeperenService.isBreak(punt);
      punt.GroupValue = punt.GroupLevel > -1 ? vm.groeperenService.groupValueList(punt.GroupLevel) : '';
      punt.Groups = vm.groeperenService.groups.slice(); // copy array
    });
    return vm;
  }

  private meetingStatusAction$ = this.toggleMyMeetingStatusSubj.pipe(
    mergeMap(zittingid => this.detailZittingService.toggleZittingAanwezig(zittingid)),
    map(IsAfwezig => (vm: IDetailZittingVm, ) => ({ ...vm, zitting: { ...vm.zitting, IsAfwezig } }))
  );

  private bookmarkAgendapunt$ = this.bookmarkAgendapuntSubj.pipe(
    mergeMap(bookmarkPunt => this.detailZittingService.toggleBookmark(bookmarkPunt.Id, bookmarkPunt.BladwijzerId)),
    shareReplay(1)
  );
  private bookmarkAgendapuntResult$ = combineLatest([this.bookmarkAgendapuntSubj, this.bookmarkAgendapunt$]).pipe(
    map(([bookmarkAgendapunt, bladwijzerId]) => ({ puntId: bookmarkAgendapunt.Id, bladwijzerId }))
  );

  private bookmarkAgendapuntAction$ = this.bookmarkAgendapuntResult$.pipe(
    map(data => (vm: IDetailZittingVm) => {
      state2.removeSubKey('detailzittingdata', vm.zitting.Id);
      const puntindex = vm.agendapunten.findIndex(p => p.Id === data.puntId);
      const newpunt = { ...vm.agendapunten[puntindex], BladwijzerId: data.bladwijzerId };
      const agendapunten = arrayReplace(vm.agendapunten, puntindex, newpunt);
      return { ...vm, agendapunten };
    })
  );

  private currentPunt$ = this.detailPuntSubj.pipe(
    scan((prev, next) => (prev && prev.Id === next.Id) ? null as IAgendapunt : next, null as IAgendapunt)
  );
  private detailPunt$ = this.currentPunt$.pipe(
    switchMap(currentPunt => this.detailZittingService.getDetailPunt(currentPunt))
  );

  detailPuntFromSubj$ = combineLatest([this.currentPunt$, this.detailPunt$]).pipe(
    map(([currentpunt, currentdetailpunt]) => (vm: IDetailZittingVm) => ({
      ...vm,
      currentpunt,
      currentdetailpunt
    }))
  );

  getStandpunten$ = this.bepaalStandpuntSubj.pipe(
    filter(punt => punt.HasCurrentUserStemrecht),
    mergeMap(punt => this.standpuntService.getStandpunten(punt.Id)),
  );

  private bepaalStandpuntAction$ = combineLatest([this.bepaalStandpuntSubj, this.getStandpunten$]).pipe(
    map(([currentStandpunt, standpunten]) => (vm: IDetailZittingVm) => ({ ...vm, currentStandpunt, standpunten })),
  );

  private closeStandpuntenAction$ = this.closeStandpuntSubj.pipe(
    map(_ => (vm: IDetailZittingVm) => ({ ...vm, standpunten: null, currentStandpunt: null }))
  );

  ngOnInit() { }

  nagivateToNotities(punt: IAgendapunt, bespreken: boolean) {
    if (!punt.HasCurrentUserNotitieRecht) { return; }
    this.appService.routing.navigateToDetailPunt(punt.ZittingId, punt.Id, bespreken, 'notities');
  }

  getAgendapuntId = (index: number, agendapunt: IAgendapunt) => agendapunt.Id;

  getDocumentZittingId = (index: number, documentZitting: IDocumentDb) => documentZitting.Id;

  filter(zittingId: number, viewState:IViewState) {
    this.appService.routing.navigateToDetailZittingKeepHistory(zittingId, viewState.name);
  }

  openDocumentZitting(document: IDocumentDb) {
    this.menuService.openDocument('zitting', document.Id, document.Titel, document.Verwijzing);
    return false;
  }

  detailPunt(zittingId: number, puntid: number, bespreken: boolean) {
    this.appService.routing.setFragment(`p_${puntid}`);
    this.appService.routing.navigateToDetailPunt(zittingId, puntid, bespreken);
    return false;
  }

  closeStandpuntHandler = () => {
    this.closeStandpuntSubj.next(true);
  }

}


